import React from 'react';
import PaymentMethodsSection from './sections/PaymentMethodsSection';

const CheckoutFormStep = () => <PaymentMethodsSection />;

export default CheckoutFormStep;
